// This is a global event service to replace AngularJS $rootScope.emit()

import { from, Subject } from 'rxjs';

export class Events {
  private listeners = {};
  private eventsSubject = new Subject();
  private events = from(this.eventsSubject);

  constructor() {
    this.events.subscribe(({ name, args }) => {
      if (this.listeners[name]) {
        for (const listener of this.listeners[name]) {
          listener(...args);
        }
      }
    });
  }

  on(name, listener): () => void {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }

    this.listeners[name].push(listener);

    return () => this.off(name, listener);
  }

  off(name, listener) {
    this.listeners[name] = this.listeners[name].filter(x => x !== listener);
  }

  broadcast(name, ...args) {
    this.eventsSubject.next({
      name,
      args
    });
  }
}

export const events = new Events();
